let authState;

export const updateAuthState = (newAuthState) => {
  authState = newAuthState;
};

export const getAuthState = () => {
  return authState;
};